import { withLoginUser } from 'src/api/user'
import { GuestPageWrapper, MemberPageWrapper } from 'src/components/PageWrapper'
import { BASE_PATH, EXHIBITIONS } from 'src/utils/routes'
import { ExhibitionSearchPageLayout } from './ExhibitionSearchPageLayout'

export const ExhibitionSearch = withLoginUser(({ user, loggedIn }) => {
  return (
    <>
      {loggedIn ? (
        <MemberPageWrapper
          user={user}
          currentPath="検索結果"
          parentPaths={[
            {
              label: 'オンライン展示会一覧',
              path: `${BASE_PATH}${EXHIBITIONS}`,
            },
          ]}
        >
          <ExhibitionSearchPageLayout />
        </MemberPageWrapper>
      ) : (
        <GuestPageWrapper
          currentPath="検索結果"
          parentPaths={[
            {
              label: 'オンライン展示会一覧',
              path: `${BASE_PATH}${EXHIBITIONS}`,
            },
          ]}
        >
          <ExhibitionSearchPageLayout />
        </GuestPageWrapper>
      )}
    </>
  )
})
